import get from "lodash/get";

import schema from "@/react/features/vcc/agent-groups/schema";

import { featureFlagColumnMapper } from "@/react/features/vcc/common";

const profileFeatureFlagMap = (flags) =>
  new Map([
    [
      schema.fields.edit_agent_display_name_enabled.spec.key,
      get(flags, "allow_agent_change_display_name", true),
    ],
    [
      schema.fields.agent_reject_enabled.spec.key,
      get(flags, "allow_agent_reject_interactions", true),
    ],
    [
      schema.fields.agent_recordings_enabled.spec.key,
      get(flags, "agent_my_recordings_enabled", true),
    ],
    [schema.fields.auto_answer_enabled.spec.key, flags.auto_answer_enabled],
    [
      schema.fields.change_phone_connection_mode.spec.key,
      get(flags, "allow_agent_change_connection_mode", true),
    ],
  ]);

export default (flags) => featureFlagColumnMapper(profileFeatureFlagMap(flags));
